import Model from "./Model";

export default class extends Model {
    constructor(urls) {
        super(urls);
        this.urls.device_add = urls.route_device_add;
        this.urls.device_del = urls.route_device_del;
        this.urls.playlist_add = urls.route_playlist_add;
        this.urls.playlist_del = urls.route_playlist_del;
        this.urls.group_default = urls.route_group_default;
    }

    async loadTable(page, limit, search, brand) {
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                limit,
                search,
                brand
            }
        }).then(response => {
            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });
        
        if(response)
        {
            let result = {
                tbody: [],
                pages: response.pages,
            };

            response.items.forEach(group => {
                let telem = {
                    tbody: {}
                };
                telem.id = group.id;
                telem.tbody.name = group.name;
                telem.tbody.device_type = group.device_type;
                telem.tbody.device_type_id = group.device_type_id;
                telem.tbody.brand_name = group.brand_name;
                telem.tbody.created_at = group.created_at;
                telem.tbody.quantity_devices = group.quantity_devices;
                telem.tbody.quantity_locations = group.quantity_locations;
                if(group.default === 1)
                {
                    telem.tbody.name += ' (Дефолтный)';
                }
                result.tbody.push(telem);
            });

            return result
        }
        return {
            tbody: [],
            pages: 0,
        };
    }

    async addDevice(group_id, device_id) {
        if(this.urls.device_add === undefined)
        {
            console.log('error: url_device_add_undefined');
            return false;
        }
        return await axios.post(this.urls.device_add, {
            group_id: group_id,
            device_id: device_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async delDevice(group_id, device_id) {
        if(this.urls.device_del === undefined)
        {
            console.log('error: url_device_del_undefined');
            return false;
        }
        return await axios.post(this.urls.device_del, {
            group_id: group_id,
            device_id: device_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async addPlaylist(group_id, playlist_id) {
        if(this.urls.playlist_add === undefined)
        {
            console.log('error: url_playlist_add_undefined');
            return false;
        }
        return await axios.post(this.urls.playlist_add, {
            group_id: group_id,
            playlist_id: playlist_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async delPlaylist(group_id, playlist_id) {
        if(this.urls.playlist_del === undefined)
        {
            console.log('error: url_playlist_del_undefined');
            return false;
        }
        return await axios.post(this.urls.playlist_del, {
            group_id: group_id,
            playlist_id: playlist_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async setDefault(group_id) {
        if(this.urls.group_default === undefined)
        {
            console.log('error: url_group_default_undefined');
            return false;
        }
        return await axios.get(this.urls.group_default+group_id).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }
}
